import SDSearch from './src/search.vue'

SDSearch.install = function (Vue) {
  Vue.component(SDSearch.name, SDSearch)
}

export default SDSearch



// WEBPACK FOOTER //
// ./src/components/sd-search/index.js